import React from "react";
import { Grid, Box, Button, SvgIcon } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { TextField } from "icw-components/InputFields";
import T from "i18n-react";

const useStyles = makeStyles(theme => ({
    uploadButton: {
        padding: "10px",
        background: "#E5ECF6",
        borderRadius: "2px",
    },
    svgIcon: {
        color: "#2154A2",
    },
    productThumbnail: {
        width: "96px",
        height: "96px",
        padding: "20px",
        position: "relative",
        "& > img": {
            display: "inline-block",
            width: "100%",
        },
    },
}));

const ProductForm = props => {
    const classes = useStyles();
    const {
        values,
        errors,
        touched = {},
        handleChange,
        handleBlur,
        setFieldTouched,
        getRootProps,
        getInputProps,
        productPhoto,
        disabled
    } = props;

    return (
        <>
            <Box display="flex" justifyContent="flex-start" pt={2} pb={2}>
                <Box fontSize="16px" fontWeight="bold" color="#232B3A">
                    {T.translate("iSource.form.subtitle")}
                </Box>
            </Box>
            <Grid container spacing={2} justify="flex-start">
                <Grid item xs={12} sm={12} md={6}>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("iSource.form.productName")}*
                    </Box>
                    <TextField
                        name="productName"
                        variant="outlined"
                        fullWidth
                        noLabel
                        placeholder={T.translate("iSource.placeholder.productName")}
                        value={values.productName}
                        error={!!(touched.productName && errors.productName)}
                        setFieldTouched={setFieldTouched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={disabled}
                    />
                    <Box fontSize="12px" fontWeight="500" color="red">
                        {touched.productName && errors.productName}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("iSource.form.material")}
                    </Box>
                    <TextField
                        name="materials"
                        variant="outlined"
                        fullWidth
                        noLabel
                        placeholder={T.translate("iSource.placeholder.material")}
                        value={values.materials}
                        onChange={handleChange}
                        disabled={disabled}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("iSource.form.other")}
                    </Box>
                    <TextField
                        name="otherRequirements"
                        variant="outlined"
                        noLabel
                        fullWidth
                        rows={5}
                        rowsMax={10}
                        multiline
                        placeholder={T.translate("iSource.placeholder.other")}
                        value={values.otherRequirements}
                        onChange={handleChange}
                        disabled={disabled}
                    />
                </Grid>
                {
                    !disabled &&
                    <Grid item xs={12} sm={12} md={6}>
                        <Box fontSize="12px" fontWeight="400">
                            {T.translate("iSource.form.uploadPhoto")}
                        </Box>
                        <Box {...getRootProps()} classes={{ root: classes.productFiles }}>
                            <input {...getInputProps()} />
                            <Button classes={{ root: classes.uploadButton }}>
                                <SvgIcon classes={{ root: classes.svgIcon }} fontSize="small">
                                    <AddIcon />
                                </SvgIcon>
                                <Box color="#2154A2" fontSize="14px" fontWeight="500">
                                    {T.translate("productManager.upload")}
                                </Box>
                            </Button>
                        </Box>
                    </Grid>
                }
                <Grid container>{productPhoto}</Grid>
            </Grid>
        </>
    );
};

ProductForm.propTypes = {
    classes: PropTypes.object,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object,
    touched: PropTypes.object,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    setFieldTouched: PropTypes.func,
    productPhoto: PropTypes.array,
    getRootProps: PropTypes.func,
    getInputProps: PropTypes.func,
};

export default ProductForm;
